/*
 * @Autor: dingxiaolin
 * @Date: 2021-02-04 18:04:59
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2023-05-10 11:17:05
 */
import Vue from 'vue';
import { MessageBox, Message } from 'element-ui';
const directive = function () {
    //防重复点击事件
    Vue.directive('noReClick', function (el: HTMLFormElement, binding) {
        el.onclick = function (e) {
            if (!el.disabled) {
                el.disabled = true;
                setTimeout(() => {
                    el.disabled = false;
                }, binding.value || 1500);
            }
        };
    });
    //无权限点击事件[button]
    Vue.directive('noPermission', function (el: HTMLFormElement, binding, vnode) {
        if( localStorage.getItem('dayChecked')=='true'){
            var authlist = localStorage.getItem("permissions") ? localStorage.getItem("permissions").split(",") : [];
        }else{
            var authlist = sessionStorage.getItem("permissions") ? sessionStorage.getItem("permissions").split(",") : [];
        }
        
        if (!authlist.includes(binding.value) || binding.value == "") {
            vnode.componentInstance.$off('click');
            vnode.componentInstance.$on('click', function () {
                Message.warning('没有权限');
            });
        };
    });
    //无权限 移除Dom元素
    Vue.directive('noPermissionDom', function (el: HTMLFormElement, binding) {
        el.setAttribute('style', 'display:none')
        if( localStorage.getItem('dayChecked')=='true'){
            var authlist = localStorage.getItem("permissions") ? localStorage.getItem("permissions").split(",") : [];
        }else{
            var authlist = sessionStorage.getItem("permissions") ? sessionStorage.getItem("permissions").split(",") : [];
        }
        
        if (authlist.includes(binding.value) || binding.value == "") {
            el.setAttribute('style', 'display:inlineblock')
        }
    });
};

export default directive;



// WEBPACK FOOTER //
// ./src/directive/index.ts